import React, { useEffect } from "react";
import MaterialTable from 'material-table';

// reactstrap components
import {
  Row,
  Col
} from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";

// views
import CadastroClassesResiduosForm from "./CadastroClassesResiduosForm.jsx";

//Context
import { useAuth } from "../../context/auth.js";

export default function CadastroClassesResiduosLista() {
  const { setLoading } = useAuth();

  const [permiteEditar, set_permiteEditar] = React.useState(false);
  const [showDetail, set_showDetail] = React.useState(false);
  const [rowEdit, set_rowEdit] = React.useState(null);
  const [list_table, set_list_table] = React.useState([]);

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    set_rowEdit(rowData);
    set_showDetail(true);
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);
    loadList();
  }

  const loadList = () => {
    setLoading(true);
    api_GET('classeresiduo')
      .then(result => set_list_table(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    ValidaAcessoFuncionalidadeAcao("CadastroClassesResiduos.Editar", function (result) { set_permiteEditar(result) });
    loadList();
  }, []);

  return (
    <>
      {!showDetail &&
        <div className="content">
          <Row>
            <Col md="12">
              <button type="button" disabled={!permiteEditar} onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Nova Classe/Resíduo</button>
              <MaterialTable style={{ minHeight: "auto" }}
                title=""

                columns={[
                  { title: 'Categoria', field: 'categoria.descricao' },
                  { title: 'Descrição', field: 'descricao' },
                  { title: 'Status', field: 'status' },
                ]}
                data={list_table}
                isLoading={false}
                options={{
                  ...table_style,
                  filtering: false,
                  exportButton: true
                }}
                actions={[
                  {
                    icon: 'edit',
                    tooltip: 'Editar Registro',
                    onClick: (event, rowData) => handleEdit(rowData)
                  }
                ]}
                localization={table_translate}
              />
            </Col>
          </Row>
        </div>
      }
      {showDetail &&
        <CadastroClassesResiduosForm item={rowEdit} handleReturn={handleReturn}></CadastroClassesResiduosForm>
      }

    </>

  );
}